// extracted by mini-css-extract-plugin
export default {"cls1":"InvitationStatusField-Grid_cls1__weXD7","cls2":"InvitationStatusField-Grid_cls2__Oli0s InvitationStatusField-Grid_cls1__weXD7"};